import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { inboxSummaryResponseSchema, type InboxSummaryResponse } from '@codemerlin/shared';

/** Matches `useInboxItemsInfinite`'s cadence so badge and list never drift far apart. */
const INBOX_SUMMARY_STALE_MS = 60_000;

export function inboxSummaryQueryKey(organizationId: string | undefined) {
  return ['inbox', 'summary', organizationId] as const;
}

/**
 * Badge count (`new_count`) plus the page-header backlog (`open_count`).
 *
 * Kept separate from the list query so the badge, which polls in every open
 * tab, does not pay for pagination or the per-work-item readiness enrichment
 * that `GET /items` performs.
 */
export function useInboxSummary(organizationId: string | undefined) {
  return useQuery({
    queryKey: inboxSummaryQueryKey(organizationId),
    enabled: Boolean(organizationId),
    refetchOnWindowFocus: true,
    refetchInterval: INBOX_SUMMARY_STALE_MS,
    queryFn: async (): Promise<InboxSummaryResponse> =>
      api.get(`organizations/${organizationId}/inbox/summary`, {
        schema: inboxSummaryResponseSchema,
      }),
  });
}
